// value must be string
export const mintFee = {
  1: '0.1',
  5: '0.1',
};

export const mintFeeUnit = {
  1: 'ETH',
  5: 'ETH',
};
